import { Component, Input } from '@angular/core';

@Component({
    selector: 'loading-skeleton',
    templateUrl: 'loading-skeleton.component.html',
    styleUrls: ['loading-skeleton.component.scss'],
})
export class LoadingSkeletonComponent {
    @Input() lines: number = 5;
}
